var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKarmaStarColored = function SvgKarmaStarColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D61F7B",
    d: "M.683 8.999C-.221 8.673-.233 7.38.678 7.077A10.12 10.12 0 0 0 7.077.678c.304-.91 1.596-.899 1.922.005A10.59 10.59 0 0 0 15.317 7c.904.326.916 1.618.005 1.922a10.12 10.12 0 0 0-6.399 6.399c-.304.91-1.596.899-1.922-.005A10.59 10.59 0 0 0 .683 9"
  })));
};
export { SvgKarmaStarColored as ReactComponent };